import React, { useEffect } from "react";
import { DataProvider } from "./context/DataContext";
import { ReactNotifications } from "react-notifications-component";
import "./App.css";
import "react-notifications-component/dist/theme.css";
// import ScrolltoTop from "./components/common-pages/ScrolltoTop";
import $ from "jquery";
import RouteConfig from "./Routes/RouteConfig";
import ScrolltoTop from "./components/ScrolltoTop";

function App() {
  useEffect(() => {
    let uselang = sessionStorage.getItem("lang");
    if (uselang == null) {
      $("html").attr("lang", "en");
      sessionStorage.setItem("lang", "en");
    } else {
      $("html").attr("lang", uselang);
      sessionStorage.setItem("lang", uselang);
    }
  }, []);
  return (
    <div className="App">
      <ReactNotifications />
      <DataProvider>
        <ScrolltoTop />
        <RouteConfig />
      </DataProvider>
    </div>
  );
}

export default App;

// "start": "NODE_ENV=development node scripts/start.js",
//   "start-prod": "NODE_ENV=production node scripts/start.js",
//     "build-dev": "NODE_ENV=development node scripts/build.js",
//       "build-prod": "NODE_ENV=production node scripts/build.js",
